import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AuthState = {
  contactUid: string | null;
  continueRoutePostLogin: string | null;
  continueRoutePostLogout: string | null;
  loggedIn: boolean;
  name: string | null;
  username: string | null;
};

export type SetLoggedInPayload = {
  contactUid: string;
  name: string;
  username: string;
};

export type SetUserActivePayload = {
  reason: string;
};

const initialState: AuthState = {
  contactUid: null,
  continueRoutePostLogin: null,
  continueRoutePostLogout: null,
  loggedIn: false,
  name: null,
  username: null,
};

export type LogoutRequestedParams = {
  continueRoutePostLogout?: string;
  reason: string;
  requestor: string;
};

export const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    clearContinueRoutePostLogin: (state) => {
      state.continueRoutePostLogin = null;
    },
    clearContinueRoutePostLogout: (state) => {
      state.continueRoutePostLogout = null;
    },
    loginRequested: () => {
      /* handled by saga */
    },
    loginSucceeded: () => {
      /* handled by saga */
    },
    logoutRequested: (_state, action: PayloadAction<LogoutRequestedParams>) => {
      /* handled by saga */

      console.warn(`Logout requested: ${JSON.stringify(action.payload)}`);
    },
    logoutStarted: () => {
      /* handled by saga */
    },
    logoutSucceeded: () => {
      /* handled by saga */
    },
    setContinueRoutePostLogin: (state, action: PayloadAction<string>) => {
      state.continueRoutePostLogin = action.payload;
    },
    setContinueRoutePostLogout: (state, action: PayloadAction<string>) => {
      state.continueRoutePostLogout = action.payload;
    },
    setLoggedIn: (state, action: PayloadAction<SetLoggedInPayload>) => {
      const { contactUid, name, username } = action.payload;
      state.loggedIn = true;
      state.username = username;
      state.contactUid = contactUid;
      state.name = name;
    },
    setLoggedOut: (state) => {
      state.loggedIn = false;
      state.username = null;
      state.contactUid = null;
      state.name = null;
    },
  },
});
